<div [style.height]="listHeight + 'px'"></div>
<div class="content" [style.transform]="'translateY(' + firstItemPosition + 'px)'">
  <ng-content></ng-content>
</div>



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/virtual-scroll/virtual-scroll.component.html